import React from "react";

class RadioControl extends React.Component {
  render() {
    const { options, value, onChange } = this.props;

    return (
      <div className="flex items-center gap-3">
        {options.map((option) => (
          <label
            key={option.value}
            className="flex cursor-pointer items-center"
          >
            <input
              type="radio"
              className="mr-1"
              value={option.value}
              checked={value === option.value}
              onChange={() => onChange(option.value)}
              disabled={option.disabled || false}
            />
            {option.label}
          </label>
        ))}
      </div>
    );
  }
}

export default RadioControl;
